"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenAmount = void 0;
const tiny_invariant_1 = __importDefault(require("tiny-invariant"));
const types_1 = require("../types");
const int256_1 = require("./int256");
class TokenAmount extends int256_1.Int256 {
    constructor(token, amount, parse = false) {
        super(amount, token.decimals, parse);
        this.token = token;
    }
    static ether(amount, chainId) {
        return new TokenAmount(types_1.Token.ether(chainId), amount);
    }
    add(other) {
        if (!other)
            return undefined;
        const newAmount = super.add(other);
        if (!newAmount)
            return undefined;
        return new TokenAmount(this.token, newAmount.raw);
    }
    sub(other) {
        if (!other)
            return undefined;
        const newAmount = super.sub(other);
        if (!newAmount)
            return undefined;
        return new TokenAmount(this.token, newAmount.raw);
    }
    div(other) {
        if (!other)
            return undefined;
        if (other instanceof TokenAmount) {
            (0, tiny_invariant_1.default)(other.token.decimals === this.token.decimals, 'Wrong decimals when dividing TokenAmounts');
        }
        const newAmount = super.div(other);
        if (!newAmount)
            return undefined;
        return new TokenAmount(this.token, newAmount.raw);
    }
    mul(other) {
        if (!other)
            return undefined;
        if (other instanceof TokenAmount) {
            (0, tiny_invariant_1.default)(other.token.decimals === this.token.decimals, 'Wrong decimals when dividing TokenAmounts');
        }
        const newAmount = super.mul(other);
        if (!newAmount)
            return undefined;
        return new TokenAmount(this.token, newAmount.raw);
    }
    rebase(base) {
        const newAmount = super.rebase(base);
        return new TokenAmount(this.token, newAmount.raw);
    }
}
exports.TokenAmount = TokenAmount;
//# sourceMappingURL=tokenAmount.js.map